export const REDIRECT_ON_AUTH_KEY = 'returnPath';
